import i18n from 'i18next';

export function translate(
  key: string | string[],
  options?: Record<string, any> | string
): string {
  // Now accepts array paths
  if (Array.isArray(key)) {
    key = key.join('.');
  }

  // Accepts default value as string (second parameter)
  if (typeof options === 'string') {
    return i18n.t(key, { defaultValue: options });
  }

  return i18n.t(key, options) as string;
}

export function exists(key: string | string[]): boolean {
  if (Array.isArray(key)) {
    key = key.join('.');
  }
  return i18n.exists(key);
}

export function createScopedTranslator(
  namespace: string
): (key: string | string[], defaultValue?: string) => string {
  return (key: string | string[], defaultValue?: string) => {
    const fullKey = Array.isArray(key)
      ? `${namespace}:${key.join('.')}`
      : `${namespace}:${key}`;

    return translate(fullKey, defaultValue);
  };
}
